<script setup lang="ts">
const { isHelpSlideoverOpen } = useDashboard()

const links = [
  {
    id: 'home',
    label: 'Home',
    icon: 'i-heroicons-home',
    to: '/',
    tooltip: {
      text: 'Home',
      shortcuts: ['G', 'H']
    }
  },
  {
    id: 'samples',
    label: 'Samples',
    icon: 'i-mdi-test-tube',
    to: '/samples',
    tooltip: {
      text: 'Samples',
      shortcuts: ['G', 'S']
    }
  }
]

const workflowLinks = [
  {
    id: 'sample-requests',
    label: 'Sample Requests',
    to: '/workflow/sample-requests',
    icon: 'i-heroicons-inbox-stack',
    shortcuts: ['G', 'R'],
    tooltip: {
      text: 'Sample Requests',
      shortcuts: ['G', 'R']
    }
  }
]

const footerLinks = [
  // {
  //   label: 'Invite people',
  //   icon: 'i-heroicons-plus',
  //   to: '/settings/members'
  // },
  {
    label: 'Help & Support',
    icon: 'i-heroicons-question-mark-circle',
    click: () => (isHelpSlideoverOpen.value = true)
  }
]

const groups = [
  {
    key: 'links',
    label: 'Go to',
    commands: [
      ...links.map(link => ({
        ...link,
        shortcuts: link.tooltip?.shortcuts
      })),
      ...workflowLinks.map(link => ({
        ...link,
        shortcuts: link.tooltip?.shortcuts
      }))
    ]
  }
]
</script>

<template>
  <UDashboardLayout>
    <UDashboardPanel :width="180" :resizable="{ min: 160, max: 220 }" collapsible>
      <UDashboardNavbar class="!border-transparent" :ui="{ left: 'flex-1' }">
        <template #left>
          <TeamsDropdown />
        </template>
      </UDashboardNavbar>

      <UDashboardSidebar>
        <template #header>
          <UDashboardSearchButton />
        </template>

        <ClientOnly>
          <UDashboardSidebarLinks :links="links" />

          <UDivider />
          <UDashboardSidebarLinks :links="workflowLinks" />

          <!-- <UDashboardSidebarLinks
            :links="[{ label: 'Colors', draggable: true, children: colors }]"
            @update:links="colors => (defaultColors = colors)"
          /> -->

          <div class="flex-1" />

          <UDashboardSidebarLinks :links="footerLinks" />
        </ClientOnly>

        <UDivider class="sticky bottom-0" />

        <template #footer>
          <UserDropdown />
        </template>
      </UDashboardSidebar>
    </UDashboardPanel>

    <slot />

    <HelpSlideover />
    <!-- <NotificationsSlideover /> -->

    <ClientOnly>
      <LazyUDashboardSearch :groups="groups" />
    </ClientOnly>
  </UDashboardLayout>
</template>
